import { render, staticRenderFns } from "./myGift.vue?vue&type=template&id=367da6d6&scoped=true"
import script from "./myGift.vue?vue&type=script&lang=js"
export * from "./myGift.vue?vue&type=script&lang=js"
import style0 from "./myGift.vue?vue&type=style&index=0&id=367da6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367da6d6",
  null
  
)

export default component.exports